export const suggestEmailDomainTypos = async (email: string) => {
  const emailSpellChecker = await import('@zootools/email-spell-checker')
  const suggestedEmail = emailSpellChecker.run({ email })
  return suggestedEmail ? suggestedEmail.full : ''
}
